module.exports = __webpack_public_path__ + "img/ernts.6ad59b2a.jpg";